module.exports = __webpack_public_path__ + "img/2e.67e5dcac.jpg";